import type { AlertingService } from '../application';

export class CompositeAlertingService implements AlertingService {
  private alertingServices: Array<AlertingService>;

  constructor(alertingServices: Array<AlertingService>) {
    this.alertingServices = alertingServices;
  }

  reportError(error: Error, extras?: any, tags?: Record<string, string>) {
    this.alertingServices.forEach(service =>
      service.reportError(error, extras, tags),
    );
  }

  reportMessage(message: string) {
    this.alertingServices.forEach(service => service.reportMessage(message));
  }

  addBreadcrumb(message: string, data?: { [key: string]: any }) {
    this.alertingServices.forEach(service =>
      service.addBreadcrumb(message, data),
    );
  }
}
